module.exports = __webpack_public_path__ + "media/images/sp/specials/common/ribbon-c0cca519087a838b44b42abf8fd5a434.svg";